import React from 'react';
import { Link } from 'react-router-dom';

export default function Progress() {
    return (
        <>
            <div className='container-fluid'>
                <div className='col-12'>
                    <nav aria-label='breadcrumb'>
                        <h2 className='mb-3'>نوار پیشرفت</h2>

                        <ol className='breadcrumb'>
                            <li className='breadcrumb-item'>
                                <Link to='/'>کامپوننت ها</Link>
                            </li>

                            <li className='breadcrumb-item'>
                                <Link to='/progress'>نوار پیشرفت</Link>
                            </li>

                            <li
                                className='breadcrumb-item active'
                                aria-current='page'
                            >
                                شما اینجایی
                            </li>
                        </ol>
                    </nav>
                </div>

                <div className='space-20' />

                <div className='row'>
                    <div className='col-md-12 col-lg-6 mb-4'>
                        <div className='card'>
                            <div className='card-title bg-transparent p-3'>
                                نوار پیشرفت معمولی
                            </div>

                            <div className='card-body'>
                                <div className='progress'>
                                    <div
                                        className='progress-bar'
                                        role='progressbar'
                                        aria-valuenow='0'
                                        aria-valuemin='0'
                                        aria-valuemax='100'
                                    />
                                </div>

                                <div className='progress'>
                                    <div
                                        className='progress-bar'
                                        role='progressbar'
                                        style={{ width: '25%' }}
                                        aria-valuenow='25'
                                        aria-valuemin='0'
                                        aria-valuemax='100'
                                    />
                                </div>

                                <div className='progress'>
                                    <div
                                        className='progress-bar'
                                        role='progressbar'
                                        style={{ width: '50%' }}
                                        aria-valuenow='50'
                                        aria-valuemin='0'
                                        aria-valuemax='100'
                                    />
                                </div>

                                <div className='progress'>
                                    <div
                                        className='progress-bar'
                                        role='progressbar'
                                        style={{ width: '75%' }}
                                        aria-valuenow='75'
                                        aria-valuemin='0'
                                        aria-valuemax='100'
                                    />
                                </div>

                                <div className='progress'>
                                    <div
                                        className='progress-bar'
                                        role='progressbar'
                                        style={{ width: '100%' }}
                                        aria-valuenow='100'
                                        aria-valuemin='0'
                                        aria-valuemax='100'
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='col-md-12 col-lg-6 mb-4'>
                        <div className='card'>
                            <div className='card-title bg-transparent p-3'>
                                نوار پیشرفت رنگی
                            </div>

                            <div className='card-body'>
                                <div className='progress'>
                                    <div
                                        className='progress-bar bg-success'
                                        role='progressbar'
                                        style={{ width: '25%' }}
                                        aria-valuenow='25'
                                        aria-valuemin='0'
                                        aria-valuemax='100'
                                    />
                                </div>

                                <div className='progress'>
                                    <div
                                        className='progress-bar bg-secondary'
                                        role='progressbar'
                                        style={{ width: '40%' }}
                                        aria-valuenow='40'
                                        aria-valuemin='0'
                                        aria-valuemax='100'
                                    />
                                </div>

                                <div className='progress'>
                                    <div
                                        className='progress-bar bg-info'
                                        role='progressbar'
                                        style={{ width: '50%' }}
                                        aria-valuenow='50'
                                        aria-valuemin='0'
                                        aria-valuemax='100'
                                    />
                                </div>

                                <div className='progress'>
                                    <div
                                        className='progress-bar bg-warning'
                                        role='progressbar'
                                        style={{ width: '75%' }}
                                        aria-valuenow='75'
                                        aria-valuemin='0'
                                        aria-valuemax='100'
                                    />
                                </div>

                                <div className='progress'>
                                    <div
                                        className='progress-bar bg-danger'
                                        role='progressbar'
                                        style={{ width: '100%' }}
                                        aria-valuenow='100'
                                        aria-valuemin='0'
                                        aria-valuemax='100'
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='col-md-12 col-lg-6 mb-4'>
                        <div className='card'>
                            <div className='card-title bg-transparent p-3'>
                                نوار پیشرفت همراه با نوشته
                            </div>

                            <div className='card-body'>
                                <div
                                    className='progress'
                                    style={{ height: '2rem' }}
                                >
                                    <div
                                        className='progress-bar'
                                        role='progressbar'
                                        style={{ width: '25%' }}
                                        aria-valuenow='25'
                                        aria-valuemin='0'
                                        aria-valuemax='100'
                                    >
                                        25%
                                    </div>
                                </div>
                                <div
                                    className='progress'
                                    style={{ height: '2rem' }}
                                >
                                    <div
                                        className='progress-bar'
                                        role='progressbar'
                                        style={{ width: '50%' }}
                                        aria-valuenow='50'
                                        aria-valuemin='0'
                                        aria-valuemax='100'
                                    >
                                        تا اتمام پروژه 50٪ مانده
                                    </div>
                                </div>
                                <div
                                    className='progress'
                                    style={{ height: '2rem' }}
                                >
                                    <div
                                        className='progress-bar'
                                        role='progressbar'
                                        style={{ width: '75%' }}
                                        aria-valuenow='75'
                                        aria-valuemin='0'
                                        aria-valuemax='100'
                                    >
                                        JavaScript 75%
                                    </div>
                                </div>
                                <div
                                    className='progress'
                                    style={{ height: '2rem' }}
                                >
                                    <div
                                        className='progress-bar'
                                        role='progressbar'
                                        style={{ width: '100%' }}
                                        aria-valuenow='100'
                                        aria-valuemin='0'
                                        aria-valuemax='100'
                                    >
                                        مهارت برنامه نویسی 100%
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='col-md-12 col-lg-6 mb-4'>
                        <div className='card'>
                            <div className='card-title bg-transparent p-3'>
                                نوار پیشرفت انیمیشنی
                            </div>

                            <div className='card-body'>
                                <div className='progress'>
                                    <div
                                        className='progress-bar progress-bar-striped progress-bar-animated'
                                        role='progressbar'
                                        aria-valuenow='75'
                                        aria-valuemin='0'
                                        aria-valuemax='100'
                                        style={{ width: '25%' }}
                                    />
                                </div>

                                <div className='progress'>
                                    <div
                                        className='progress-bar progress-bar-striped progress-bar-animated bg-secondary'
                                        role='progressbar'
                                        aria-valuenow='50'
                                        aria-valuemin='0'
                                        aria-valuemax='100'
                                        style={{ width: '50%' }}
                                    />
                                </div>

                                <div className='progress'>
                                    <div
                                        className='progress-bar progress-bar-striped progress-bar-animated bg-info'
                                        role='progressbar'
                                        aria-valuenow='60'
                                        aria-valuemin='0'
                                        aria-valuemax='100'
                                        style={{ width: '60%' }}
                                    />
                                </div>

                                <div className='progress'>
                                    <div
                                        className='progress-bar progress-bar-striped progress-bar-animated bg-danger'
                                        role='progressbar'
                                        aria-valuenow='75'
                                        aria-valuemin='0'
                                        aria-valuemax='100'
                                        style={{ width: '75%' }}
                                    />
                                </div>

                                <div className='progress'>
                                    <div
                                        className='progress-bar progress-bar-striped progress-bar-animated bg-dark'
                                        role='progressbar'
                                        aria-valuenow='90'
                                        aria-valuemin='0'
                                        aria-valuemax='100'
                                        style={{ width: '90%' }}
                                    />
                                </div>

                                <div className='progress'>
                                    <div
                                        className='progress-bar progress-bar-striped progress-bar-animated bg-warning'
                                        role='progressbar'
                                        aria-valuenow='100'
                                        aria-valuemin='0'
                                        aria-valuemax='100'
                                        style={{ width: '100%' }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
